module.exports = __webpack_public_path__ + "img/icon-select.b06ad61b.svg";